import { render, staticRenderFns } from "./Lista_UtilizxBeneficiario_pdf.vue?vue&type=template&id=5e39bd51&"
import script from "./Lista_UtilizxBeneficiario_pdf.vue?vue&type=script&lang=js&"
export * from "./Lista_UtilizxBeneficiario_pdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports